import { useInfiniteQuery } from "@tanstack/react-query";
import { getProfessionalStatusLogs } from "../services/get-professional-status-logs";

export function useProfessionalStatusLogs(
  professionalId: string | undefined,
  limit = 20
) {
  return useInfiniteQuery({
    queryKey: ["professional-status-logs", professionalId],
    enabled: !!professionalId,
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      getProfessionalStatusLogs(professionalId as string, pageParam, limit),
    getNextPageParam: (last) => last.nextPage ?? undefined,
    refetchOnWindowFocus: false,
  });
}
